import { render } from "./newlive.vue?vue&type=template&id=6e76db08&scoped=true&ts=true"
import script from "./newlive.vue?vue&type=script&lang=ts"
export * from "./newlive.vue?vue&type=script&lang=ts"

import "./newlive.vue?vue&type=style&index=0&id=6e76db08&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e76db08"]])

export default __exports__